export default function loadVimeoPoster(videoId) {
  return new Promise((resolve) => {
    const url = `https://vimeo.com/api/oembed.json?url=https://vimeo.com/${videoId}`;

    fetch(url)
      .then((res) => res.json())
      .then((res) => {
        resolve(typeof res.thumbnail_url !== 'undefined' ? res.thumbnail_url : '');
      });
  });
}
